import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import {
  verifyToken,
  updateBrokerProfile,
  getBrokerInformation,
  getInsurerCreds,
  getBrokerInsurerList,
  updateInsurerCreds,
  getRefetchInsurerList,
  getUpdatedProfile,
} from "../store/broker";
import { getBrokerageInformation, getDetails } from "../store/brokerage";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select from "react-dropdown-select";
import UploadBrokerImage from "../components/UploadBrokerImage";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import ReactSelect from "react-select";
import {
  getUserInformation,
  getUserDetails,
  getUpdateButtonStatus,
  toggleUpdateButton,
  geNewUserModelStatus,
  toggleNewUserModel,
  getUpdateUserModelStatus,
  toggleUpdateUserModel,
  selectUpdateUser,
  getUpdateUserSelected,
  updateDetails,
  getAllUsersList,
  getAllUsers,
  addNewUser,
  getUpdateErrors,
  getBrokerageInfo,
} from "../store/userManagement";
import { toast } from "react-toastify";
import { tr } from "date-fns/locale";
import { sendSignupEmail, storeEmailId } from "../store/passwordManagement";
import {
  updatePassword,
  getPasswordSuccess,
  getIsLoading,
} from "../store/passwordManagement";
import translations from "../utils/translations";

const UserManagement = (props) => {
  let { view } = props;
  return <UserManagementPane view={view}></UserManagementPane>;
};
const UserManagementPane = (props) => {
  const isUpdateEnabled = useSelector(getUpdateButtonStatus);
  const { view } = props;
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  const updatedProfile = useSelector(getUpdatedProfile);
  const refetchInsurerList = useSelector(getRefetchInsurerList);
  let data = { brokerage_code: broker.information.brokeragecode };
  const [addressList, setAddressList] = useState(null);
  // useEffect(() => {
  //   dispatch(getUserDetails(data)).then(
  //     setTimeout(() => {
  //       dispatch(getDetails(data));
  //     }, 100)
  //   );
  // }, []);
  const brokerage_info = useSelector(getBrokerageInformation);
  const userInformation = useSelector(getBrokerInformation);
  const languagepreference = userInformation?.information?.languagepreference || "en";
  const userManagementTranslations =
    translations[languagepreference].userManagement;
  useEffect(() => {
    setAddressList(brokerage_info?.address);
  }, [brokerage_info]);
  useEffect(() => {
    dispatch(getInsurerCreds(broker.information));
  }, []);

  useEffect(() => {
    // after update button is pressed and we finished persisting data,
    //lets re-fetch new data to update redux values
    if (updatedProfile) {
      dispatch(verifyToken());
    }
  }, [updatedProfile]);

  useEffect(() => {
    if (refetchInsurerList) {
      toast.success(
        userManagementTranslations.insuranceCredentialsChangedSuccessfully
      );
      dispatch(getInsurerCreds(broker.information));
    }
  }, [refetchInsurerList]);

  let userList = [broker.information];
  const onUpdateChangeHandle = (value) => {
    dispatch(toggleUpdateButton(value));
  };

  const onNewUserModelChangeHandle = (value) => {
    dispatch(getAllUsers());
    dispatch(toggleNewUserModel(value));
  };

  const onUpdateUserModelChangeHandle = (value, user) => {
    dispatch(selectUpdateUser(user));

    dispatch(toggleUpdateUserModel(value));
  };
  const updateUser = broker.information; //useSelector(getUpdateUserSelected);
  if (view == "security") {
    return (
      <div className="m-4">
        <UpdatePass
          brokerageCode={data.brokerage_code}
          user={updateUser}
          brokerageAddressList={addressList ? addressList.address : []}
        ></UpdatePass>
      </div>
    );
  }
  if (view == "bmscreds") {
    return (
      <div className="m-4">
        <UpdateBMSCreds
          brokerageCode={data.brokerage_code}
          user={updateUser}
          brokerageAddressList={addressList ? addressList.address : []}
        ></UpdateBMSCreds>
      </div>
    );
  }
  if (view == "insuredcreds") {
    return (
      <div className="m-4">
        <UpdateInsurerCreds
          brokerageCode={data.brokerage_code}
          user={updateUser}
          brokerageAddressList={addressList ? addressList.address : []}
        ></UpdateInsurerCreds>
      </div>
    );
  } else {
    return (
      <div className="m-4">
        <UpdateUser
          brokerageCode={data.brokerage_code}
          user={updateUser}
          brokerageAddressList={addressList ? addressList : []}
        ></UpdateUser>
      </div>
    );
  }
};

const ColoredLine = ({ color }) => (
  <hr
    style={{
      color: color,
      backgroundColor: color,
      height: 1,
    }}
  />
);
const UpdateUser = (updateUser) => {
  const user = updateUser.user;
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const userManagementTranslations =
    translations[languagepreference].userManagement;
  const previewCanvasRef = useRef(null);
  const [selecteduser, setSelecteduser] = useState({
    uName: user.firstname + " " + user.lastname,
    uEmail: user.user.email,
    uContact: user.phonenumber,
    uLocation: user.location
      ? user.location
      : user.brokerages[0]
      ? user.brokerages[0].address[0] || user.brokerages[0].address
        ? user.brokerages[0].address[0]
          ? user.brokerages[0].address[0].city
          : user.brokerages[0].address.city
        : ""
      : "",
    uImage: user.image,
    uRole: user.jobrole,
    uBiography: user.bio,
    uAdmin: user.isadmin,
    uId: user._id,
  });
  const dispatch = useDispatch();
  const [bio, setBio] = useState(null);
  const onLocationChangeHandler = (values) => {
    setSelecteduser({
      ...selecteduser,
      uLocation: values[0].value,
    });
  };
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
            >
              {userManagementTranslations.personalInformation}
            </span>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-8">
            <form noValidate>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementTranslations.email}
                </label>
                <div className="col-sm-9">
                  <input
                    type="email"
                    id="uEmail"
                    name="uEmail"
                    className="form-control"
                    placeholder={userManagementTranslations.enterEmail}
                    defaultValue={user.user.email}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {}}
                    disabled
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementTranslations.name}
                </label>
                <div className="col-sm-9">
                  <input
                    autoFocus
                    type="text"
                    id="uName"
                    name="uName"
                    className="form-control"
                    placeholder={userManagementTranslations.enterName}
                    defaultValue={user.firstname + " " + user.lastname}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uName: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementTranslations.phoneNumber}
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="uContact"
                    name="uContact"
                    className="form-control"
                    placeholder={userManagementTranslations.enterPhoneNumber}
                    defaultValue={user.phonenumber}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uContact: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementTranslations.roleJobTitle}
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="uRole"
                    name="uRole"
                    className="form-control"
                    placeholder={userManagementTranslations.enterRoleJobTitle}
                    defaultValue={user.jobrole}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uRole: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementTranslations.biography}
                </label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    id="biography"
                    name="biography"
                    rows="3"
                    className="form-control"
                    placeholder={userManagementTranslations.enterBiography}
                    style={{ backgroundColor: "#d6dae6" }}
                    defaultValue={selecteduser.uBiography}
                    onChange={(event) => {
                      setBio(event.target.value);
                      setSelecteduser({
                        ...selecteduser,
                        uBiography: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementTranslations.location}
                </label>
                <div className="col-sm-9">
                  <Select
                    color={theme.COLORS.primary_navyblue}
                    placeholder={
                      selecteduser?.uLocation
                        ? selecteduser.uLocation
                        : "please choose"
                    }
                    options={
                      updateUser.brokerageAddressList
                        ? updateUser.brokerageAddressList.map(
                            ({ addr_line1, city, postal_code }) => ({
                              value:
                                addr_line1 + " " + city + " " + postal_code,
                              label:
                                addr_line1 + " " + city + " " + postal_code,
                            })
                          )
                        : []
                    }
                    onChange={(values) => onLocationChangeHandler(values)}
                    style={{
                      width: "100%",
                      height: "6vh",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }}
                  />
                </div>
              </div>

              <UploadBrokerImage
                selecteduser={selecteduser}
                user={user}
                setSelecteduser={setSelecteduser}
                broker={broker}
                previewCanvasRef={previewCanvasRef}
              ></UploadBrokerImage>

              <div className="form-group row justify-content-center" style={{'paddingBottom':'4vh'}}>
                <div className="col-6">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#4cabd4",
                      borderRadius: "20px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      let code = {
                        brokerage_code: broker.information.brokerages[0].code,
                      };
                      let data = {
                        firstname: selecteduser.uName
                          .split(" ")
                          .slice(0, -1)
                          .join(" "),
                        lastname: selecteduser.uName
                          .split(" ")
                          .slice(-1)
                          .join(" "),
                        phonenumber: selecteduser.uContact,
                        location: selecteduser.uLocation,
                        isadmin: selecteduser.uAdmin,
                        brokerage_code: broker.information.brokerages[0].code,
                        jobrole: selecteduser.uRole,
                        bio: selecteduser.uBiography,
                        id: selecteduser.uId,

                        brokerProspectsPermissions:
                          selecteduser.uProspectPermissions,
                      };
                      var b64 = previewCanvasRef?.current?.toDataURL("image");
                      if (b64) {
                        data.brokerimage = b64;
                      } else if (selecteduser.uImage) {
                        data.brokerimage = selecteduser.uImage;
                      }

                      dispatch(
                        updateBrokerProfile({
                          type: "personalinfo",
                          data: data,
                          broker: broker.information,
                        })
                      );
                    }}
                  >
                    {userManagementTranslations.update}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};

const UpdatePass = (updateUser) => {
  const user = updateUser.user;
  const broker = useSelector(getBrokerInformation);
  const passwordSuccess = useSelector(getPasswordSuccess);
  const isLoading = useSelector(getIsLoading);
  const previewCanvasRef = useRef(null);
  const languagepreference = broker.information.languagepreference;
  const userManagementTranslations =
    translations[languagepreference].userManagement;
  const [selecteduser, setSelecteduser] = useState({
    uName: user.firstname + " " + user.lastname,
    uEmail: user.user.email,
    uContact: user.phonenumber,
    uLocation: user.location
      ? user.location
      : user.brokerages[0]
      ? user.brokerages[0].address[0] || user.brokerages[0].address
        ? user.brokerages[0].address[0]
          ? user.brokerages[0].address[0].city
          : user.brokerages[0].address.city
        : ""
      : "",
    uImage: user.image,
    uRole: user.jobrole,
    uBiography: user.bio,
    uAdmin: user.isadmin,
    uId: user._id,
  });
  const [password, setPassword] = useState(false);
  const [passwordConfirmation, setPasswordConfirmation] = useState(false);
  const [lastpassword, setLastPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorDisplay, seterrorDisplay] = useState("none");
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const dispatch = useDispatch();
  const onLocationChangeHandler = (values) => {
    setSelecteduser({
      ...selecteduser,
      uLocation: values[0].value,
    });
  };
  useEffect(() => {
    if (!isLoading && passwordSuccess && lastpassword != password) {
      toast.success(userManagementTranslations.passwordChangedSuccessfully);
      setLastPassword(password);
    }
  }, [passwordSuccess, isLoading]);

  useEffect(() => {
    if (password.length && passwordConfirmation.length) {
      if (
        password != passwordConfirmation &&
        !password.startsWith(passwordConfirmation)
      ) {
        seterrorDisplay("block");
      } else {
        seterrorDisplay("none");
      }
    } else {
      seterrorDisplay("none");
    }
  }, [password, passwordConfirmation]);
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
            >
              {userManagementTranslations.updatePassword}
            </span>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-8">
            <form noValidate>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {" "}
                  {userManagementTranslations.email}
                </label>
                <div className="col-sm-9">
                  <TextField
                    label={null}
                    style={{ backgroundColor: "#d6dae6", fontWeight: "bold" }}
                    variant="outlined"
                    type="text" // <-- This is where the magic happens
                    disabled
                    value={user.user.email}
                    autoComplete="new-password"
                    onChange={(event) =>
                      setSelecteduser({
                        ...selecteduser,
                        uEmail: event.target.value,
                      })
                    }
                    InputProps={{
                      // <-- This is where the toggle button is added.
                      style: { fontWeight: "bold" },
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ width: "2rem" }}
                        />
                      ),
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementTranslations.newPassword}
                </label>
                <div className="col-sm-9">
                  <TextField
                    label={null}
                    style={{ backgroundColor: "#d6dae6" }}
                    variant="outlined"
                    type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                    // onChange={() => {}}
                    autoComplete="new-password"
                    onBlur={(e) => setPassword(e.target.value)}
                    InputProps={{
                      // <-- This is where the toggle button is added.
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleClickShowPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementTranslations.confirmPassword}
                </label>
                <div className="col-sm-9">
                  <TextField
                    label={null}
                    style={{ backgroundColor: "#d6dae6" }}
                    variant="outlined"
                    type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                    // onChange={() => {}}
                    autoComplete="new-password"
                    onChange={(e) => setPasswordConfirmation(e.target.value)}
                    InputProps={{
                      // <-- This is where the toggle button is added.
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleClickShowPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  color: "red",
                  fontSize: "x-small",
                  display: errorDisplay,
                }}
                className="form-group row"
              >
                {userManagementTranslations.passwordsDoNotMatch}
              </div>

              <div className="form-group row justify-content-center">
                <div className="col-6">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#4cabd4",
                      borderRadius: "20px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      if (password) {
                        let data = {
                          email: user.user.email,
                          updatedpassword: password,
                          bypass: true,
                        };
                        dispatch(updatePassword(data));
                      }
                    }}
                  >
                    {userManagementTranslations.update}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};

const UpdateBMSCreds = (updateUser) => {
  const user = updateUser.user;
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const userManagementTranslations =
    translations[languagepreference].userManagement;
  const previewCanvasRef = useRef(null);
  const dispatch = useDispatch();
  var initalSet = broker.information.otherinfo?.bms
    ? [...broker.information.otherinfo?.bms]
    : [null, null, null];
  const [bmsCreds, setbmsCreds] = useState(initalSet);
  const handlBlur = (index, value) => {
    setbmsCreds((prevCrd) => {
      prevCrd[index] = value;
      return prevCrd;
    });
  };
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
            >
              {userManagementTranslations.updateBrokerManagementCreds}
            </span>
            <br />
            <br />
            <p
              className="text-center"
              style={{ fontFamily: "Gibson", fontSize: "15px" }}
            >
              {userManagementTranslations.addBmsDetails}
            </p>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-8">
            <form noValidate>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {" "}
                  {userManagementTranslations.bmsUsername}
                </label>
                <div className="col-sm-9">
                  <input
                    autoFocus
                    type="text"
                    id="uName"
                    name="uName"
                    className="form-control"
                    placeholder={userManagementTranslations.enterName}
                    defaultValue={bmsCreds[0]}
                    style={{ backgroundColor: "#d6dae6" }}
                    onBlur={(event) => handlBlur(0, event.target.value)}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {" "}
                  {userManagementTranslations.bmsField1}
                </label>
                <div className="col-sm-9">
                  <input
                    autoFocus
                    type="text"
                    id="uName"
                    name="uName"
                    className="form-control"
                    placeholder={userManagementTranslations.enterField1}
                    defaultValue={bmsCreds[1]}
                    style={{ backgroundColor: "#d6dae6" }}
                    onBlur={(event) => handlBlur(1, event.target.value)}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementTranslations.bmsField2}
                </label>
                <div className="col-sm-9">
                  <input
                    autoFocus
                    type="text"
                    id="uName"
                    name="uName"
                    className="form-control"
                    placeholder={userManagementTranslations.enterField2}
                    defaultValue={bmsCreds[2]}
                    style={{ backgroundColor: "#d6dae6" }}
                    onBlur={(event) => handlBlur(2, event.target.value)}
                  />
                </div>
              </div>

              <div className="form-group row justify-content-center">
                <div className="col-6">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#4cabd4",
                      borderRadius: "20px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      dispatch(
                        updateBrokerProfile({
                          type: "bms",
                          creds: bmsCreds,
                          broker: broker.information,
                        })
                      );
                    }}
                  >
                    {userManagementTranslations.update}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};

const UpdateInsurerCreds = (updateUser) => {
  const user = updateUser.user;
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const userManagementTranslations =
    translations[languagepreference].userManagement;
  const previewCanvasRef = useRef(null);
  const dispatch = useDispatch();
  const insurerList = useSelector(getBrokerInsurerList);
  const [_insurerList, setinsurerList] = useState(insurerList);
  var insurers = [{ name: "test1" }, { name: "test3" }, { name: "test2" }];
  insurers = insurerList;
  useEffect(() => {
    setinsurerList(insurerList);
  }, [insurerList]);
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
            >
              {userManagementTranslations.updateInsuranceCredentials}
            </span>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-8">
            <form noValidate>
              <label className="col-sm-2 col-form-label">
                {" "}
                {userManagementTranslations.insurer}
              </label>
              <label className="col-md-5 col-form-label">
                {" "}
                {userManagementTranslations.username}
              </label>
              <label className="col-sm-5 col-form-label">
                {" "}
                {userManagementTranslations.password}
              </label>
              {_insurerList.map((insurer, idx) => (
                <InsurerRow
                  insurer={insurer}
                  user={user}
                  insurerListpublic={insurerList}
                  setinsurerList={setinsurerList}
                  index={idx}
                  _insurerListP={_insurerList}
                />
              ))}

              <div className="form-group row justify-content-center" style={{paddingBottom:'4vh'}}>
                <div className="col-6">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#4cabd4",
                      borderRadius: "20px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      dispatch(
                        updateInsurerCreds({
                          creds: _insurerList,
                          broker: broker.information,
                        })
                      );
                    }}
                  >
                    {userManagementTranslations.update}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};

const InsurerRow = (props) => {
  const {
    insurer,
    user,
    index,
    insurerListpublic,
    setinsurerList,
    _insurerListP,
  } = props;
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const userManagementTranslations =
    translations[languagepreference].userManagement;
  const handleBlurChange = (event, field) => {
    // const updatedInsurerList = _insurerListP.map((item, idx) =>
    //       idx === index ? { ...item, [field]: event.target.value } : item
    // );
    setinsurerList((prevArr) => {
      let nextUse = prevArr.map((item, idx) =>
        idx === index ? { ...item, [field]: event.target.value } : item
      );
      return nextUse;
    });
    // setinsurerList(updatedInsurerList)
  };
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  return (
    <div key={index} className="form-group row">
      <label key={`${index}_name`} className="col-sm-2 col-form-label">
        {insurer.name}
      </label>
      <div className="col-md-5">
        <input
          key={`${index}_username`}
          autoFocus
          type="text"
          id="uName"
          name="uName"
          className="form-control"
          placeholder={userManagementTranslations.username}
          defaultValue={insurer.username}
          style={{ backgroundColor: "#d6dae6" }}
          onBlur={(event) => handleBlurChange(event, "username")}
        />
      </div>
      <div className="col-md-5">
        <TextField
          label={null}
          key={`${index}_password`}
          variant="outlined"
          type={showPassword ? "text" : "password"} // <-- This is where the magic happens
          // onChange={() => {}}
          style={{ maxHeight: "6vh" }}
          defaultValue={insurer.password}
          onBlur={(e) => handleBlurChange(e, "password")}
          InputProps={{
            // <-- This is where the toggle button is added.
            style: {
              height: "4.5vh",
              padding: "0 1px",
            },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleClickShowPassword}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
};

export default UserManagement;
